import React from "react";
import { Section, SectionHeading } from "@/components/layout/Section";
import { MicroLabel } from "@/components/common/MicroLabel";
import { Reveal } from "@/components/common/Reveal";
import { REQUEST_STATUS } from "@/content/homeContent";

export const RequestStatus = () => {
  const { states } = REQUEST_STATUS;

  return (
    <Section id="request-status-section" tone="dark" className="bg-strato-nearblack">
      <Reveal>
        <SectionHeading
          microLabel={REQUEST_STATUS.microLabel}
          title={REQUEST_STATUS.title}
          description={REQUEST_STATUS.description}
        />
      </Reveal>

      <Reveal delay={0.08}>
        <div
          data-testid="request-status-widget"
          className="mt-10 rounded-2xl border border-white/10 bg-white/[0.03] p-6 shadow-dark sm:p-8"
        >
          {/* header row */}
          <div className="flex flex-col gap-3 border-b border-white/10 pb-6 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-3">
              <MicroLabel className="text-white/40">RIF.</MicroLabel>
              <span className="font-mono text-sm text-white">
                {REQUEST_STATUS.referenceLabel}
              </span>
            </div>
            <span
              data-testid="request-status-current-state"
              className="inline-flex w-fit items-center gap-2 rounded-full bg-[var(--strato-blue-soft)] px-3 py-1"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-strato-blue" />
              <span className="strato-micro text-strato-blue">
                5 stati chiari
              </span>
            </span>
          </div>

          {/* progress bar */}
          <div className="mt-6">
            <div
              className="h-1.5 w-full overflow-hidden rounded-full bg-white/10"
              role="progressbar"
              aria-valuenow={0}
              aria-valuemin={0}
              aria-valuemax={100}
              data-testid="request-status-progress"
            >
              <div
                className="h-full rounded-full bg-strato-blue transition-all duration-500"
                style={{ width: "0%" }}
              />
            </div>
          </div>

          {/* timeline steps */}
          <ol className="mt-8 grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 lg:grid-cols-7">
            {states.map((s, i) => {
              return (
                <li
                  key={s.key}
                  data-testid={`request-status-step-${i}`}
                  className="flex items-center gap-3 lg:flex-col lg:items-start"
                >
                  <span
                    className={
                      "grid h-8 w-8 flex-shrink-0 place-items-center rounded-full border text-xs font-semibold " +
                      "border-white/15 bg-transparent text-white/40"
                    }
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="lg:mt-1">
                    <span
                      className="block text-xs leading-tight text-white/45"
                    >
                      {s.label}
                    </span>
                  </div>
                </li>
              );
            })}
          </ol>

          <p className="strato-micro mt-8 text-white/35">
            CONTROLLA LO STATO DALLA PAGINA DEDICATA
          </p>
        </div>
      </Reveal>
    </Section>
  );
};
